"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _react = _interopRequireWildcard(require("react"));

var ContinueIcon = function ContinueIcon(props) {
  return _react["default"].createElement("svg", (0, _extends2["default"])({}, props, {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }), _react["default"].createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, _react["default"].createElement("path", {
    d: "M0 0h24v24H0z"
  }), _react["default"].createElement("path", {
    fill: "currentColor",
    d: "M8.228 2.715C3.156 4.762.681 10.593 2.708 15.713c2.028 5.12 7.804 7.62 12.876 5.572a9.887 9.887 0 0 0 5.428-5.349 1.003 1.003 0 0 0-.52-1.312.986.986 0 0 0-1.3.524 7.91 7.91 0 0 1-4.344 4.28c-4.057 1.637-8.678-.363-10.301-4.458a8.08 8.08 0 0 1-.5-2.008h8.601l-.98.99a1.006 1.006 0 0 0 0 1.414.983.983 0 0 0 1.4 0l2.626-2.65a1.004 1.004 0 0 0 0-1.415l-2.765-2.79a.983.983 0 0 0-1.4 0 1.007 1.007 0 0 0 0 1.414l1.028 1.037H4.054c.364-2.775 2.157-5.28 4.909-6.39 4.058-1.639 8.679.361 10.301 4.457a.987.987 0 0 0 1.288.558c.507-.205.755-.787.552-1.3C19.076 3.167 13.3.667 8.228 2.715zm11.383 9.814c.255.642.976.953 1.61.697.635-.256.944-.984.69-1.625a1.235 1.235 0 0 0-1.61-.696 1.253 1.253 0 0 0-.69 1.624z"
  })));
};

ContinueIcon.defaultProps = {
  width: "24px",
  height: "24px",
  "aria-label": "Continue",
  color: "#ffffff"
};
var _default = ContinueIcon;
exports["default"] = _default;